"use client";

import React from "react";
import { Button } from "@west-tennessee-consulting/ui";
import type { ResearchImportResult } from "./types";

interface ImportResultsStepProps {
  results: ResearchImportResult[];
  onDone: () => void;
}

export function ImportResultsStep({ results, onDone }: ImportResultsStepProps) {
  return (
    <div className="space-y-4">
      <div className="text-sm font-medium">Import Results</div>

      <div className="space-y-2 max-h-96 overflow-y-auto">
        {results.map((result, idx) => (
          <div
            key={idx}
            className={`p-3 rounded border text-sm ${
              result.action === "failed"
                ? "bg-red-50 border-red-200 dark:bg-red-950/40 dark:border-red-800"
                : "bg-green-50 border-green-200 dark:bg-green-950/40 dark:border-green-800"
            }`}
          >
            <div className="font-medium">
              {result.contact.name || result.contact.email || "Unknown"}
            </div>
            <div className="text-xs mt-1">
              {result.action === "failed" ? (
                <span className="text-red-700 dark:text-red-300">Failed: {result.error}</span>
              ) : (
                <span className="text-green-700 dark:text-green-300">
                  {result.action === "created" ? "Created" : "Merged"}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <Button onClick={onDone} className="w-full">
        Done
      </Button>
    </div>
  );
}
